document.addEventListener('DOMContentLoaded', function () {
 var popup = document.querySelector('[data-email-signup-popup]');
 if (!popup) return;
 var overlay = popup.querySelector('[data-email-signup-overlay]');
 var closeButtons = popup.querySelectorAll('[data-email-signup-close]');
 var continueButton = popup.querySelector('[data-email-signup-continue]');
 var nextButton = popup.querySelector('[data-email-signup-next]');
 var form = popup.querySelector('[data-email-signup-form]');
 var messageEl = popup.querySelector('[data-email-signup-message]');
 var emailInput = form ? form.querySelector('input[name="email"]') : null;
 var submitButton = form ? form.querySelector('button[type="submit"]') : null;
 var marketingCheckbox = form ? form.querySelector('[data-email-signup-marketing]') : null;
 var STORAGE_PREFIX = 'email_signup_popup_v1_';
 var CLOSED_KEY = STORAGE_PREFIX + 'closed_at';
 var SUBMITTED_KEY = STORAGE_PREFIX + 'submitted';
 var CLOSED_COOKIE = STORAGE_PREFIX + 'closed';
 var SUBMITTED_COOKIE = STORAGE_PREFIX + 'submitted';
 var ONE_DAY_MS = 24 * 60 * 60 * 1000;
 var delaySeconds = parseInt(popup.getAttribute('data-delay-seconds') || '8', 10);
 var closeDays = parseInt(popup.getAttribute('data-close-days') || '10', 10);
 var publicKey = (popup.getAttribute('data-klaviyo-public-key') || '').trim();
 var listId = (popup.getAttribute('data-klaviyo-list-id') || '').trim();
 var sheetUrl = (popup.getAttribute('data-sheet-url') || '').trim();
 var defaultError = popup.getAttribute('data-default-error') || 'Please try again.';
 function parseExcludedPaths(value) {
   if (!value) return [];
   return value
     .split('\n')
     .map(function (line) { return line.trim(); })
     .filter(function (line) { return line.length > 0; });
 }
 var excludedPaths = parseExcludedPaths(popup.getAttribute('data-excluded-paths'));
 function getCookie(name) {
   var target = name + '=';
   var parts = document.cookie ? document.cookie.split(';') : [];
   for (var i = 0; i < parts.length; i += 1) {
     var cookie = parts[i].trim();
     if (cookie.indexOf(target) === 0) return cookie.substring(target.length);
   }
   return '';
 }
 function setCookie(name, value, maxAgeSeconds) {
   document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAgeSeconds;
 }
 function removeCookie(name) {
   document.cookie = name + '=; path=/; max-age=0';
 }
 function safeSetStorage(key, value) {
   try { localStorage.setItem(key, value); } catch (_) {}
 }
 function safeGetStorage(key) {
   try { return localStorage.getItem(key) || ''; } catch (_) { return ''; }
 }
 function safeRemoveStorage(key) {
   try { localStorage.removeItem(key); } catch (_) {}
 }
 function isAllowedPath(pathname) {
   if (pathname === '/') return true;
   if (pathname === '/collections' || pathname.indexOf('/collections/') === 0) return true;
   if (pathname === '/products' || pathname.indexOf('/products/') === 0) return true;
   if (pathname === '/blogs' || pathname.indexOf('/blogs/') === 0) return true;
   return false;
 }
 function isBlockedPath(pathname) {
   var blockedPrefixes = [
     '/cart', '/checkout', '/account', '/pages/contact',
     '/pages/wholesale', '/pages/find-a-stockist', '/pages/safety',
     '/pages/limited-warranty', '/pages/registration'
   ];
   for (var i = 0; i < blockedPrefixes.length; i += 1) {
     if (pathname === blockedPrefixes[i] || pathname.indexOf(blockedPrefixes[i] + '/') === 0) return true;
   }
   for (var j = 0; j < excludedPaths.length; j += 1) {
     var path = excludedPaths[j];
     if (pathname === path || pathname.indexOf(path + '/') === 0) return true;
   }
   return false;
 }
 function hasSubmittedSuppression() {
   return safeGetStorage(SUBMITTED_KEY) === '1' || getCookie(SUBMITTED_COOKIE) === '1';
 }
 function setSubmittedSuppression() {
   safeSetStorage(SUBMITTED_KEY, '1');
   setCookie(SUBMITTED_COOKIE, '1', 3650 * 24 * 60 * 60);
 }
 function hasClosedSuppression() {
   var now = Date.now();
   var closeMs = closeDays * ONE_DAY_MS;
   var closedAtRaw = safeGetStorage(CLOSED_KEY);
   var closedAt = closedAtRaw ? parseInt(closedAtRaw, 10) : 0;
   if (!closedAt) {
     var cookieAt = parseInt(getCookie(CLOSED_COOKIE) || '0', 10);
     closedAt = cookieAt || 0;
   }
   if (!closedAt) return false;
   if (now - closedAt >= closeMs) {
     safeRemoveStorage(CLOSED_KEY);
     removeCookie(CLOSED_COOKIE);
     return false;
   }
   return true;
 }
 function setClosedSuppression() {
   var now = Date.now();
   safeSetStorage(CLOSED_KEY, String(now));
   setCookie(CLOSED_COOKIE, String(now), closeDays * 24 * 60 * 60);
 }
 // --- Step management ---
 function showStep(stepName) {
   popup.classList.remove('is-capture', 'is-success');
   if (stepName === 'capture') popup.classList.add('is-capture');
   if (stepName === 'success') popup.classList.add('is-success');
 }
 function openPopup() {
   popup.style.display = 'block';
   popup.getBoundingClientRect();
   popup.classList.add('is-visible');
   document.body.classList.add('email-signup-popup-open');
   showStep('intro');
 }
 function closePopup(setCloseFlag) {
   popup.classList.remove('is-visible');
   document.body.classList.remove('email-signup-popup-open');
   if (setCloseFlag) setClosedSuppression();
   window.setTimeout(function () {
     if (!popup.classList.contains('is-visible')) {
       popup.style.display = 'none';
       showStep('intro');
     }
   }, 320);
 }
 function validateEmail(email) {
   return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
 }
 function setMessage(text, type) {
   if (!messageEl) return;
   messageEl.textContent = text || '';
   messageEl.classList.remove('is-error', 'is-success');
   if (type === 'error') messageEl.classList.add('is-error');
   if (type === 'success') messageEl.classList.add('is-success');
 }
 function switchToSuccessStep() {
   popup.classList.add('is-transitioning');
   setMessage('', '');
   window.setTimeout(function () {
     showStep('success');
     popup.classList.remove('is-transitioning');
     setSubmittedSuppression();
   }, 160);
 }
 function submitToSheet(email, wantsMarketing) {
   var payload = new URLSearchParams();
   payload.append('email', email);
   payload.append('marketing', wantsMarketing ? '1' : '0');
   payload.append('page', window.location.pathname);
   // no-cors: Apps Script doesn't send CORS headers, but the data still arrives.
   return fetch(sheetUrl, {
     method: 'POST',
     mode: 'no-cors',
     keepalive: true,
     headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
     body: payload.toString()
   });
 }
 function submitToKlaviyo(email) {
   var payload = new URLSearchParams();
   payload.append('g', listId);
   payload.append('email', email);
   if (publicKey) {
     payload.append('$source', 'shopify_theme_popup');
     payload.append('a', publicKey);
   }
   return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
     method: 'POST',
     keepalive: true,
     headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
     body: payload.toString()
   }).then(function (response) {
     if (!response.ok) throw new Error('Klaviyo signup failed');
     return response.json();
   });
 }
 // --- Event listeners ---
 if (overlay) {
   overlay.addEventListener('click', function () { closePopup(true); });
 }
 closeButtons.forEach(function (btn) {
   btn.addEventListener('click', function (event) {
     event.preventDefault();
     closePopup(true);
   });
 });
 if (nextButton) {
   nextButton.addEventListener('click', function () {
     showStep('capture');
     if (emailInput) emailInput.focus();
   });
 }
 if (continueButton) {
   continueButton.addEventListener('click', function () { closePopup(false); });
 }
 if (form && emailInput && submitButton) {
   form.addEventListener('submit', function (event) {
     event.preventDefault();
     var email = (emailInput.value || '').trim();
     var wantsMarketing = !!(marketingCheckbox && marketingCheckbox.checked);
     setMessage('', '');

     if (!validateEmail(email)) {
       setMessage(defaultError, 'error');
       return;
     }
     if (!sheetUrl) {
       setMessage('Popup is not configured yet. Add the spreadsheet URL in section settings.', 'error');
       return;
     }
     if (wantsMarketing && !listId) {
       setMessage('Popup is not configured yet. Add a Klaviyo List ID in section settings.', 'error');
       return;
     }

     submitButton.disabled = true;

     // Send both in the background, at the same time
     submitToSheet(email, wantsMarketing).catch(function (err) {
       console.warn('Sheet signup failed', err);
     });
     if (wantsMarketing) {
       submitToKlaviyo(email).catch(function (err) {
         console.warn('Klaviyo signup failed', err);
       });
     }

     // Show the final screen straight away
     switchToSuccessStep();
   });
 }
 // --- Display logic ---
 var pathname = window.location.pathname || '/';
 var shouldDisplayPopup = false;
 try {
   shouldDisplayPopup =
     isAllowedPath(pathname) &&
     !isBlockedPath(pathname) &&
     !hasSubmittedSuppression() &&
     !hasClosedSuppression();
 } catch (_) {
   shouldDisplayPopup = false;
 }
 if (!shouldDisplayPopup) return;
 window.setTimeout(function () {
   openPopup();
 }, Math.max(1, delaySeconds) * 1000);
});